import type { GlobalSearchResultsData } from '../types';

export const getSelectedSearchResult = (searchResults: GlobalSearchResultsData, navigationId: number) => {
    const allItems = searchResults?.groups?.flatMap(group => group.items);
    const selectedResult = allItems?.find(item => item.navigation_id === navigationId);

    return selectedResult;
};
